<style scoped>
.carousel-product-list-wrap {
    flex: 1 1 0%;
    width: 0;
    overflow: hidden;
}
/*edge*/
@supports (-ms-ime-align: auto) {
    .carousel-product-list-wrap {
        flex: 1 1 auto;
    }
}
/*ie*/
@media screen and (-ms-high-contrast: none) {
    .carousel-product-list-wrap {
        flex: 1 1 auto;
        width: 100%;
    }
}
.carousel-product-list {
    transition: all 700ms ease-in-out;
}
.carousel-product-list-btn {
    outline: 0 !important;
    @apply text-secondary;
}
.carousel-product-list-btn[disabled] {
    @apply text-gray-100;
}
</style>
<template>
    <div :style="bgStyle">
        <div
            class="mx-2 text-darkGrayishBlue text-2xl font-black text-center"
            v-if="title"
        >
            {{ title }}
        </div>
        <div class="flex flex-row">
            <slot name="leftButton" :pos="pos">
                <button
                    class="btn border-0 p-0 -ml-3 btn-disabled-reset carousel-product-list-btn"
                    :disabled="pos === 0"
                    @click="pos = Math.max(0, pos - theStep)"
                >
                    <div class="icon w-12 h-12">
                        <chevronLeft class="fill-current" />
                    </div>
                </button>
            </slot>

            <div class="carousel-product-list-wrap" ref="wrapper">
                <div
                    class="relative flex flex-row flex-no-wrap carousel-product-list"
                    ref="productList"
                >
                    <div
                        class="flex justify-center m-3 w-full"
                        v-if="!list.length"
                    >
                        <spinner />
                    </div>
                    <div
                        v-for="(p, pi) in list"
                        :key="pi"
                        class=" flex-shrink-0"
                        :class="productWidthClass"
                    >
                        <slot
                            name="product"
                            :product="p"
                            :index="pi"
                            :pos="pos"
                        >
                            <productBlock
                                :product="p"
                                productWidthClass="w-full"
                            />
                        </slot>
                    </div>

                    <div :class="productWidthClass" v-if="$scopedSlots.append">
                        <slot name="append"></slot>
                    </div>
                </div>
            </div>

            <slot name="rightButton" :pos="pos">
                <button
                    class="btn border-0 p-0 -mr-3 btn-disabled-reset carousel-product-list-btn"
                    :disabled="pos >= listLength - items"
                    @click="pos = Math.min(pos + theStep, listLength - items)"
                >
                    <div class="icon w-12 h-12">
                        <chevronRight class="fill-current" />
                    </div>
                </button>
            </slot>
        </div>
        <slot name="footer"></slot>
    </div>
</template>

<script>
import chevronLeft from '../assets/svg/chevron_left.svg';
import chevronRight from '../assets/svg/chevron_right.svg';
import productBlock from '@/components/productBlock.vue';
import spinner from '@/components/spinner.vue';

const defaultNumOfProductInCurrentScreenSize = screen => {
    if (screen === 'lg' || screen === 'xl') {
        return 3;
    }
    if (screen === 'sm' || screen === 'md') {
        return 2;
    }
    return 1;
};

export default {
    components: { chevronLeft, chevronRight, productBlock, spinner },
    props: {
        title: { type: String },
        list: { type: Array, default: () => [] },
        //step: { default: 1 },
        bgStyle: { default: '' },
        productListClass: { type: String, default: '-mx-4 lg:-mx-8' },
        productWidthClass: {
            type: String,
            default: 'w-full sm:w-1/2 lg:w-1/3 flex-shrink-0'
        },
        getNumOfProductInCurrentScreenSize: {
            type: Function,
            default: defaultNumOfProductInCurrentScreenSize
        }
    },
    data: () => ({
        pos: 0,
        screen: ''
    }),
    computed: {
        margin() {
            const productListStyle = window.getComputedStyle(
                this.$refs.productList,
                null
            );
            const marginLeft =
                parseFloat(
                    productListStyle.marginLeft.replace(/[^-\d.]/g, '')
                ) || 0;
            const marginRight =
                parseFloat(
                    productListStyle.marginRight.replace(/[^-\d.]/g, '')
                ) || 0;
            return marginLeft + marginRight;
        },
        items() {
            return this.getNumOfProductInCurrentScreenSize(this.screen);
        },
        step() {
            return this.items;
        },
        theStep() {
            return Math.min(this.items, this.step);
        },
        listLength() {
            return this.list.length + (this.$scopedSlots.append ? 1 : 0);
        }
    },
    mounted() {
        const detectScreen = () => {
            if (window.innerWidth >= 1280) {
                this.screen = 'xl';
            } else if (window.innerWidth >= 1024) {
                this.screen = 'lg';
            } else if (window.innerWidth >= 768) {
                this.screen = 'md';
            } else if (window.innerWidth >= 640) {
                this.screen = 'sm';
            } else {
                this.screen = '';
            }
        };
        const styleLeft = () => {
            if (!this.$refs.wrapper || !this.$refs.productList) {
                return;
            }
            this.$refs.productList.style.left =
                (-1 *
                    this.pos *
                    (this.$refs.wrapper.offsetWidth + this.margin)) /
                    this.items +
                'px';
        };
        detectScreen();
        this.resize = function() {
            detectScreen();
            styleLeft();
        };
        window.addEventListener('resize', this.resize);
        // window.addEventListener('orientationchange', this.resize);

        this.$watch('pos', styleLeft, { immediate: true });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resize);
        // window.removeEventListener('orientationchange', this.resize);
    }
};
</script>
